module.exports = __webpack_public_path__ + "img/international.a70d4453.png";